import React from "react";

const KNOWN_ICONS = ["vehicle", "fieldservices", "inventory", "maintenance"];

export default function ReportDefinitionHead({ name, type }) {
  const icon = KNOWN_ICONS.includes(type) ? type : "fieldservices";
  return (
    <>
      <div className="report-definition-head">
        <img src={`assets/Reports/${icon}.svg`} alt={type} />
        <div className="text-capitalize">{name}</div>
      </div>
    </>
  );
}
